import { render } from "./BreadcrumbNav.vue?vue&type=template&id=73c07d4c&ts=true"
import script from "./BreadcrumbNav.vue?vue&type=script&lang=ts"
export * from "./BreadcrumbNav.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__